import {StagedWord} from "../../../../../common/types/words";
import {VocabularyActionDispatch} from "../../../pages/Vocabulary";
import React, {memo} from "react";
import {Box} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import ColoredWordCardView from "./ColoredWordCardView";
import useWordList from "../hooks/useWordList";
import WordInfoView from "../../WordInfoView/WordInfoView";

export interface ColoredWordListViewProps {
    words: StagedWord[]
    colorByStages: boolean
    stageSymbol: 'up' | 'down' | 'none'
    actionDispatch?: VocabularyActionDispatch<StagedWord>
}

const ColoredWordListView = memo(({words, colorByStages, stageSymbol, actionDispatch} : ColoredWordListViewProps) => {

    const {selectedWord, setSelectedWord, currentWordList, actionDispatch: newActionDispatch} = useWordList<StagedWord>(words, actionDispatch);
    const theme = useTheme();
    const stageColors = theme.custom.srsLevelColors;

    const getStageColor = (stage: number) => stageColors[stage] ?? stageColors[0];

    return (
        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1}}>
            {currentWordList.map((word, index) => (
                <ColoredWordCardView
                    key={index}
                    word={word}
                    backgroundColor={colorByStages ? getStageColor(word.stage) : undefined}
                    stageSymbol={stageSymbol}
                    onWordClicked={setSelectedWord}
                />
            ))}
            {selectedWord && (
                <WordInfoView
                    word={selectedWord}
                    onDrawerClosed={() => setSelectedWord(null)}
                    actionDispatch={newActionDispatch as VocabularyActionDispatch}
                />
            )}
        </Box>
    );
})


export default ColoredWordListView;